import { FC, useEffect, useMemo } from "react";
import Heading from "components/Heading/Heading";
import Glide from "@glidejs/glide";
import { TaxonomyType } from "data/types";
import CardCategory3 from "components/CardCategory3/CardCategory3";
import CardCategory4 from "components/CardCategory4/CardCategory4";
import NextPrev from "shared/NextPrev/NextPrev";
import CardCategory5 from "components/CardCategory5/CardCategory5";
import useNcId from "hooks/useNcId";
import first from "images/OT_homepage_awards_eit-digital-2022.jpg";
import second from "images/OT_homepage_awards_capsulet-2023.jpg";
import third from "images/OT_homepage_awards_startsmart-2023.jpg";
export interface SectionSliderNewCategoriesProps {
  className?: string;
  itemClassName?: string;
  heading?: string;
  subHeading?: string;
  categories?: TaxonomyType[];
  categoryCardType?: "card3" | "card4" | "card5";
  itemPerRow?: 3 | 4 | 5;
  sliderStyle?: "style1" | "style2";
  uniqueClassName: string;
}



const DEMO_CATS: TaxonomyType[] = [
  {
    id: "1",
    href: "https://www.eitdigital.eu/newsroom/news/2022/eit-digital-celebrates-the-launch-of-31-new-startups-from-the-2022-edition-of-the-venture-program/",
    name: "powered by the European Union",
    date: "2022",
    taxonomy: "category",
    count: 17288,
    thumbnail: first,
  },
  {
    id: "2",
    href: "https://www.capsuletaccelerator.gr/orbito-travel/",
    name: "powered by the Hellenic Chamber of Hotels",
    date: "2023",
    taxonomy: "category",
    count: 17288,
    thumbnail: second
  },
  {
    id: "3",
    href: "https://startsmartsee.org/upcoming-program/",
    name: "powered by the MIT J-WEL Network",
    date: "2023",
    taxonomy: "category",
    count: 17288,
    thumbnail: third
  },
];

const SectionSliderNewCategories: FC<SectionSliderNewCategoriesProps> = ({
  heading = "Top destinations",
  subHeading = "including fully accessible results",
  className = "",
  itemClassName = "",
  categories = DEMO_CATS,
  itemPerRow = 3,
  categoryCardType = "card3",
  sliderStyle = "style1",
  uniqueClassName,
}) => {
  const UNIQUE_CLASS =
    "SectionSliderNewCategories__" + uniqueClassName + useNcId();

  let MY_GLIDEJS = useMemo(() => {
    return new Glide(`.${UNIQUE_CLASS}`, {
      perView: itemPerRow,
      gap: 32,
      bound: true,
      breakpoints: {
        1280: {
          perView: itemPerRow - 1,
        },
        1024: {
          gap: 20,
          perView: itemPerRow - 1,
        },
        768: {
          gap: 20,
          perView: itemPerRow - 2,
        },
        640: {
          gap: 20,
          perView: itemPerRow - 3,
        },
        500: {
          gap: 20,
          perView: 1.3,
        },
      },
    });
  }, [UNIQUE_CLASS]);

  useEffect(() => {
    setTimeout(() => {
      MY_GLIDEJS.mount();
    }, 100);
  }, [MY_GLIDEJS, UNIQUE_CLASS]);

  const renderCard = (item: TaxonomyType, index: number) => {
    switch (categoryCardType) {
      case "card3":
        return <CardCategory3 taxonomy={item} />;
      case "card4":
        return <CardCategory4 taxonomy={item} />;
      case "card5":
        return <CardCategory5 taxonomy={item} />;
      default:
        return <CardCategory3 taxonomy={item} />;
    }
  };

  return (
    <div className={`nc-SectionSliderNewCategories ${className}`}>
      <div className={`${UNIQUE_CLASS} flow-root`}>
        <Heading
          desc={subHeading}
          hasNextPrev={sliderStyle === "style1"}
        >
          {heading}
        </Heading>
        <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides">
            {categories.map((item, index) => (
              <li key={index} className={`glide__slide ${itemClassName}`}>
                {renderCard(item, index)}
              </li>
            ))}
          </ul>
        </div>

        {/* {sliderStyle === "style2" && (
          <NextPrev className="justify-center mt-16" />
        )} */}
      </div>
    </div>
  );
};

export default SectionSliderNewCategories;
